import { RootState } from "@/store/store";
import { taskManagementTargetSelector } from "@/store/task-management/selectors/form/target/common/taskManagementTargetSelector";

export const taskManagementTargetResourceMasterGridIdSelector = (
  state: RootState,
) => {
  const target = taskManagementTargetSelector(state);

  return target?.resourcesMasterGridId;
};
